export const convertStringDateToUnix = (dateStr: string) => {
  // let date = '20240401'
  let year = dateStr.slice(0, 4)
  let month = dateStr.slice(4, 6)
  let day = dateStr.slice(6, 8)
  // let date = new Date(`${year}-${month}-${day}`)
  return new Date(`${year}-${month}-${day}`).getTime()

}